import Text from './Text';

export { TextProps } from './Text';

export default Text;
